import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WalletIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Wallet",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.32 9.28H7c-.82 0-1.5-.57-1.68-1.33-.02-.11-.03-.23-.03-.35 0-.93.75-1.68 1.68-1.68h18.04c.82 0 1.5-.57 1.68-1.33.02-.11.03-.23.03-.35 0-.93-.75-1.68-1.68-1.68h-18C4.26 2.56 2 4.82 2 7.6v16.8c0 2.78 2.26 5.04 5.04 5.04h21.28c.93 0 1.68-.75 1.68-1.68v-16.8c0-.93-.75-1.68-1.68-1.68M23.28 21.6c-1.24 0-2.24-1-2.24-2.24s1-2.24 2.24-2.24 2.24 1 2.24 2.24-1 2.24-2.24 2.24"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.43 29H5.57c-3.15 0-5.71-2.56-5.71-5.71V9.58c0-3.16 2.56-5.72 5.71-5.72h20.57a1.14 1.14 0 1 1 0 2.28H5.57c-1.89 0-3.43 1.54-3.43 3.43v13.71c0 1.89 1.54 3.43 3.43 3.43h22.86c.63 0 1.14-.51 1.14-1.14V11.86c0-.63-.51-1.14-1.14-1.14H5.57a1.14 1.14 0 1 1 0-2.28h22.86c1.89 0 3.43 1.54 3.43 3.43v13.71c0 1.89-1.54 3.43-3.43 3.43Z"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "23.86",
        cy: "18.71",
        r: "1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.86 21c-1.26 0-2.29-1.03-2.29-2.29s1.03-2.29 2.29-2.29 2.29 1.02 2.29 2.29S25.13 21 23.86 21"
      })]
    })
  }));
};
WalletIcon.displayName = 'WalletIcon';